import { IListItem } from "../../interface/list-item";
import RadioButton from "./radio-button";

interface IOwnProps {
    groupClassName?: string;
    itemClassName?: string;
    options: Array<IListItem>;
    onSelect: (value: string) => void;
    value: string;
}

const RadioButtonGroup = ({
    groupClassName,
    itemClassName,
    options,
    onSelect,
    value,
}: IOwnProps) => (
    <div className={groupClassName}>
        {options.map((option) => (
            <RadioButton
                key={option.id}
                className={itemClassName}
                option={option}
                isChecked={option.id === value}
                onSelect={() => onSelect(option.id)}
            />
        ))}
    </div>
);

export default RadioButtonGroup;
